module.exports = __webpack_public_path__ + "img/ged.6ff33c44.jpg";